<template>
    <div class="chat-area">
        <div class="chat-header flex flex-vertical-center">
            <img class="chat-icon" src="@images/player/chat.png" />
            <span>聊天区</span>
        </div>
        <div
            ref="chat-scrollbar"
            class="chat-container scrollbar"
            :style="{ bottom: showEditor ? '154px' : 0 }"
        >
            <div class="chat-list">
                <message
                    v-for="(chat, index) in messageList"
                    :key="index"
                    :nickName="
                        chat.username ? chat.username : `${chat.fromusername} 对 ${chat.tousername}`
                    "
                    :content="chat.msg"
                    :showAvatar="false"
                    :layout="chat.isMe ? 'right' : 'left'"
                    class="chat-item"
                ></message>
            </div>
        </div>
        <div v-if="showEditor" class="chat-editor-area flex flex-column">
            <el-input
                v-model="content"
                type="textarea"
                class="flex-item chat-editor"
                :autosize="false"
                resize="none"
                placeholder="请输入聊天消息"
            >
            </el-input>
            <div class="flex flex-end chat-editor-footer">
                <el-button type="text" class="send-btn" round @click="handleSendMsg"
                    >发送</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import Message from './Message.vue';
export default {
    name: 'ChatArea',
    components: { Message },
    props: {
        messageList: {
            type: Array,
            default: () => []
        },
        showEditor: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            content: ''
        };
    },
    updated() {
        const $chatScrollerBar = this.$refs['chat-scrollbar'];
        $chatScrollerBar.scrollTo(0, $chatScrollerBar.scrollHeight);
    },
    methods: {
        handleSendMsg() {
            this.$emit('send', this.content);
            this.content = '';
        }
    }
};
</script>

<style lang="scss" scoped>
.chat-area {
    height: 100%;
    position: relative;
}
.chat {
    &-header {
        height: 46px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 500;
        color: #bbbbbb;
        padding: 14px 16px;
        background: #2b2b2d;
    }
    &-icon {
        width: 19px;
        height: 19px;
        object-fit: contain;
        margin-right: 7px;
    }
    &-container {
        width: 100%;
        position: absolute;
        top: 56px;
        left: 0;
        right: 0;
        bottom: 154px;
    }
    &-list {
        padding: 0 17px;
    }
    &-item {
        & + & {
            margin-top: 17px;
        }
    }
}
.chat-editor {
    &::v-deep {
        .el-textarea__inner {
            height: 100%;
            background-color: transparent;
            border: none;
            padding: 15px 24px;
            color: #bbbbbb;
            scrollbar-color: #545454 transparent;
            scrollbar-width: thin;
            &::placeholder {
                color: #5e5e60;
            }
            &::-webkit-scrollbar-track-piece {
                background-color: transparent;
                border-radius: 0;
            }
            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }
            &::-webkit-scrollbar-thumb {
                height: 50px;
                background-color: #545454;
                outline-offset: -2px;
                border-radius: 6px;
                // outline: 2px solid #fff;
                // border: 2px solid #fff;
                filter: alpha(opacity = 50);
                -moz-opacity: 0.5;
                -khtml-opacity: 0.5;
                opacity: 0.5;
            }
            &::-webkit-scrollbar-thumb:hover {
                height: 50px;
                background-color: #878987;
                border-radius: 6px;
            }
        }
    }
    &-area {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 144px;
        margin-top: 10px;
        background: #2b2b2d;
    }
    &-footer {
        padding: 10px;
    }
}
.send-btn {
    padding: 10px 19px !important;
    line-height: 14px !important;
}
</style>
